var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tool"},[_c('nav',_vm._l((_vm.indexData.menus),function(tool){return _c('div',{key:tool.id + 'tool',staticClass:"item"},[(
          tool.url.indexOf('http') == -1 &&
          tool.url.indexOf('com') == -1 &&
          tool.url.indexOf('cn') == -1
        )?_c('router-link',{attrs:{"to":tool.url}},[_c('img',{attrs:{"src":tool.pic,"alt":tool.name,"title":tool.name}}),_c('p',[_vm._v(_vm._s(tool.name))])]):_c('a',{attrs:{"href":tool.url}},[_c('img',{attrs:{"src":tool.pic,"alt":tool.name,"title":tool.name}}),_c('p',[_vm._v(_vm._s(tool.name))])])],1)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }